"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
function apply(patches, cache, staleEntities) {
    if (patches.length === 0) {
        return [cache, staleEntities];
    }
    // Make a shallow copy of the cache
    var cacheCopy = __assign({}, cache);
    // Make a shallow copy of the stale entities
    var staleEntitiesCopy = __assign({}, staleEntities);
    for (var _i = 0, patches_1 = patches; _i < patches_1.length; _i++) {
        var patch = patches_1[_i];
        switch (patch.type) {
            case "InvalidateEntity": {
                applyInvalidateEntity(patch, cacheCopy, staleEntitiesCopy);
                break;
            }
            case "InvalidateField": {
                applyInvalidateField(patch, cacheCopy, staleEntitiesCopy);
                break;
            }
            case "CreateEntity": {
                applyCreateEntity(patch, cacheCopy);
                break;
            }
            case "DeleteEntity": {
                applyDeleteEntity(patch, cacheCopy);
                break;
            }
            case "UpdateField": {
                applyUpdateField(patch, cacheCopy);
                break;
            }
            case "InsertElement": {
                applyInsertElement(patch, cacheCopy);
                break;
            }
            case "RemoveElement": {
                applyRemoveElement(patch, cacheCopy);
                break;
            }
            case "RemoveEntityElement": {
                applyRemoveEntityElement(patch, cacheCopy);
                break;
            }
            default: {
                var exhaustiveCheck = function (x) { return x; };
                exhaustiveCheck(patch);
            }
        }
    }
    return [cacheCopy, staleEntitiesCopy];
}
exports.apply = apply;
function applyInvalidateEntity(patch, cache, staleEntities) {
    var entity = cache[patch.id];
    if (entity !== undefined) {
        for (var _i = 0, _a = Object.keys(entity); _i < _a.length; _i++) {
            var entityKey = _a[_i];
            console.log(entityKey);
            invalidateRecursive(cache, staleEntities, entity[entityKey]);
        }
    }
}
function applyInvalidateField(patch, cache, staleEntities) {
    var _a;
    if (cache[patch.id] !== undefined) {
        // We want to invalidate all fields that start with the specified
        // field name in order to invlidate fields with arguments
        // For example the fields "products" and "products(ids: [1, 2])" should
        // both be invalidated if the field name "products" is specified
        var entityFieldKeys = Object.keys(cache[patch.id]).filter(function (k) { return k.indexOf(patch.fieldName) !== -1; });
        if (entityFieldKeys.length === 0) {
            return;
        }
        for (var _i = 0, entityFieldKeys_1 = entityFieldKeys; _i < entityFieldKeys_1.length; _i++) {
            var fieldKey = entityFieldKeys_1[_i];
            staleEntities[patch.id] = __assign({}, staleEntities[patch.id], (_a = {}, _a[fieldKey] = true, _a));
            // Shallow mutation of stale entities OK as we have a shallow copy
            invalidateRecursive(cache, staleEntities, cache[patch.id][fieldKey]);
        }
    }
}
function invalidateRecursive(cache, staleEntities, startingEntity) {
    if (typeof startingEntity === "number" ||
        typeof startingEntity === "boolean" ||
        startingEntity === "undefined" ||
        startingEntity === "null") {
        return;
    }
    var stack = [];
    if (typeof startingEntity === "string" && cache[startingEntity]) {
        stack.push(startingEntity);
    }
    else if (isArrayOfEntityIds(cache, startingEntity)) {
        stack.push.apply(stack, startingEntity);
    }
    while (stack.length > 0) {
        var entityId = stack.shift();
        var entity = cache[entityId];
        if (entity === undefined) {
            continue;
        }
        var entityFieldKeys = Object.keys(entity);
        var newStaleEntity = __assign({}, staleEntities[entityId]);
        for (var _i = 0, entityFieldKeys_2 = entityFieldKeys; _i < entityFieldKeys_2.length; _i++) {
            var entityFieldKey = entityFieldKeys_2[_i];
            var entityField = entity[entityFieldKey];
            if (isArrayOfEntityIds(cache, entityField)) {
                stack.push.apply(stack, entityField.filter(function (id) { return !staleEntities[id]; }));
            }
            else if (typeof entityField === "string" &&
                cache[entityField] &&
                !staleEntities[entityField]) {
                stack.push(entityField);
            }
            newStaleEntity[entityFieldKey] = true;
        }
        staleEntities[entityId] = newStaleEntity;
    }
}
function isArrayOfEntityIds(cache, field) {
    if (Array.isArray(field) && field.some(function (x) { return !!cache[x]; })) {
        return true;
    }
    return false;
}
function applyCreateEntity(patch, cache) {
    // Shallow mutation OK as we have a shallow copy
    cache[patch.id] = patch.newValue;
}
function applyDeleteEntity(patch, cache) {
    if (entityExists(cache, patch)) {
        // Shallow mutation of cache OK as we have a shallow copy
        delete cache[patch.id];
    }
}
function applyUpdateField(patch, cache) {
    var _a;
    if (entityAndFieldExists(cache, patch)) {
        // Shallow mutation of cache OK as we have a shallow copy
        cache[patch.id] = __assign({}, cache[patch.id], (_a = {}, _a[patch.fieldName] = patch.newValue, _a));
    }
}
function applyInsertElement(patch, cache) {
    var _a;
    if (entityAndFieldExists(cache, patch)) {
        // Shallow mutation of cache OK as we have a shallow copy
        // tslint:disable-next-line:no-any
        var arrCopy = cache[patch.id][patch.fieldName] === null
            ? []
            : cache[patch.id][patch.fieldName].slice();
        arrCopy.splice(patch.index, 0, patch.newValue);
        cache[patch.id] = __assign({}, cache[patch.id], (_a = {}, _a[patch.fieldName] = arrCopy, _a));
    }
}
function applyRemoveElement(patch, cache) {
    var _a;
    if (entityAndFieldExists(cache, patch)) {
        // tslint:disable-next-line:no-any
        var arrCopy = cache[patch.id][patch.fieldName].slice();
        arrCopy.splice(patch.index, 1);
        // Shallow mutation of cache OK as we have a shallow copy
        cache[patch.id] = __assign({}, cache[patch.id], (_a = {}, _a[patch.fieldName] = arrCopy, _a));
    }
}
function applyRemoveEntityElement(patch, cache) {
    var _a;
    if (entityAndFieldExists(cache, patch)) {
        var arr = cache[patch.id][patch.fieldName];
        // Shallow mutation of cache OK as we have a shallow copy
        cache[patch.id] = __assign({}, cache[patch.id], (_a = {}, _a[patch.fieldName] = arr.filter(function (x) { return x !== patch.entityId; }), _a));
    }
}
function entityAndFieldExists(cache, patch) {
    return !!(cache[patch.id] && cache[patch.id][patch.fieldName] !== undefined);
}
function entityExists(cache, patch) {
    return !!cache[patch.id];
}
//# sourceMappingURL=apply.js.map